import { Button, Stack, Typography } from "@mui/material";
import type { NikolaAction } from "@chessla/shared";

const spendsCredits = (action: NikolaAction): boolean =>
  action.type === "start_game_analysis" || action.type === "evaluate_line";

export const ChatActions = ({
  actions,
  disabled,
  estimatedCredits,
  embedded,
  onAction,
}: {
  actions: readonly NikolaAction[];
  disabled?: boolean;
  estimatedCredits?: number | null;
  embedded?: boolean;
  onAction: (action: NikolaAction) => void;
}) => (
  <Stack gap={0.65} sx={{ mt: 1.25 }}>
    <Stack gap={0.65}>
      {actions.map((action, index) => (
        <Button
          key={`${action.type}:${action.gameId ?? action.patternId ?? action.fen ?? action.draftId ?? action.exportId ?? index}`}
          size="small"
          variant="outlined"
          disabled={disabled && spendsCredits(action)}
          onClick={() => onAction(action)}
          endIcon={<span aria-hidden>→</span>}
          sx={{
            borderRadius: 0,
            width: "100%",
            minHeight: 44,
            px: 1.25,
            justifyContent: "space-between",
            borderColor: "primary.main",
            color: "primary.main",
            fontSize: ".64rem",
            fontWeight: 900,
            letterSpacing: ".055em",
            textTransform: "uppercase",
            "&:hover": { bgcolor: "primary.main", color: "background.default", borderColor: "primary.main" },
          }}
        >
          {action.label}
        </Button>
      ))}
    </Stack>
    {!embedded && estimatedCredits != null && actions.some(spendsCredits) && (
      <Typography sx={{ color: "text.secondary", fontSize: ".56rem" }}>
        COACHED FOLLOW-UP · Only pay for what Nikola uses
      </Typography>
    )}
  </Stack>
);
